
















































































































































































































































































import {
  AchievementsCards,
  ActivitiesCards,
  AdminsCards,
  BadgesCards,
  GcoinsCards,
  GrantingCards,
  OpportunityRoleCards,
  SkillsCards,
} from '@/components/rules';
import {
  AchievementType,
  ActivityGroup,
  Badge,
} from '@/models';
import { RewardableActivity, GcoinsAward, GcoinsAwards } from '@/models/gcoins';
import { Gratification } from '@/models/rules';
import { rulesMixin } from '@/shared';
import { Actions, Getters, typedStore } from '@/store';
import mixins from 'vue-typed-mixins';
import GCoinsAwardsCards from '@/components/rules/GCoinsAwardsCards.vue';

export default mixins(rulesMixin).extend({
  name: 'RulesView',
  components: {
    GCoinsAwardsCards,
    AchievementsCards,
    ActivitiesCards,
    AdminsCards,
    BadgesCards,
    GcoinsCards,
    GrantingCards,
    OpportunityRoleCards,
    SkillsCards,
  },
  computed: {
    achievements(): AchievementType[] {
      return typedStore(this).state.achievements.allAchievements;
    },
    activities(): ActivityGroup[] {
      return typedStore(this).state.activities.all;
    },
    badges(): Badge[] {
      return typedStore(this).state.badges.allBadges;
    },
    gCoins(): RewardableActivity[] {
      return typedStore(this).state.gCoins.activities;
    },
    gCoinsAwards(): GcoinsAward[] {
      return GcoinsAwards;
    },
    skills(): ActivityGroup[] {
      return typedStore(this).getters[Getters.activities.grouped];
    },
    gratifications(): Gratification[] {
      return typedStore(this).state.activities.gratifications;
    },
  },
  methods: {
    async fetchData() {
      await Promise.all([
        this.$store.dispatch(Actions.activities.fetchAll),
        this.$store.dispatch(Actions.gCoins.fetchAwards),
        this.$store.dispatch(Actions.achievements.fetchAllAchievements),
        this.$store.dispatch(Actions.badges.fetchBadges),
        this.$store.dispatch(Actions.geek.fetchAdmins),
        this.$store.dispatch(Actions.activities.fetchGratifications),
      ]);

      if (this.$isAccessible(this.$permissions.opportunity)) {
        await Promise.all([
          this.$store.dispatch(Actions.opportunities.fetchIssuers),
          this.$store.dispatch(Actions.opportunities.fetchAdmins),
        ]);
      }
    },
  },
});
